export var SDK_VERSION = '6.11.0';
//# sourceMappingURL=version.js.map